import PermissionGuard from 'components/Global/PermissionGuard';
import LoanMovementReportComponent from 'components/Report/LoanMovementReport';

const LoanMovementReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<LoanMovementReportComponent />
		</PermissionGuard>
	);
};

export default LoanMovementReport;
